module.exports = __webpack_public_path__ + "static/media/50d.1186186b.svg";